// PNG
export const avatar = require("./avatar.png").default;
export const edit = require("./edit.png").default;
export const apple = require("./apple.png").default;
export const google = require("./google.png").default;
export const defaultSpace = require("./spaceDefault.png").default;

// SVG as component
export { ReactComponent as Fireworks } from "./fireworks.svg";
